import styled from "styled-components"

import { ButtonNew } from "components/form/ButtonNew"

const TableNavButton = styled(ButtonNew)`
  position: absolute;
  right: 24px;
  top: 24px;
  display: flex;
`

const StyledTabsWrapper = styled.div`
  width: 100%;
  button {
    font-size: 16px;
  }
`

const TabsContainer = styled.div`
  display: flex;
  margin-top: 16px;
  width: 100%;
  border-bottom: 1px solid #cbd5e1;
  margin-bottom: 15px;
`

const ReportingPeriod = styled.div`
  font-size: 16px;
  font-weight: 300;
  color: #475569;
  margin-top: -5px;
`

const Tab = styled.button<{ active: boolean; tabColor?: string }>`
  color: ${({ active, tabColor }) => {
    if (tabColor) {
      return tabColor
    }
    return active ? "#334155" : "#64748b"
  }};
  margin-right: 24px;
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 14px;
  margin-bottom: -1px;
  border: none;
  border-bottom: 1px solid
    ${({ active, tabColor }) => {
      if (active && tabColor) {
        return tabColor
      }
      return active ? "#2db2c8" : "transparent"
    }};
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;
  opacity: ${({ active }) => (active ? 1 : 0.7)};

  &:hover {
    opacity: 1;
    color: ${({ tabColor }) => tabColor || "#334155"};
  }
`

const STATUS_TABS = [
  { label: "High", value: "high", color: "#EF4444" },
  { label: "Medium", value: "medium", color: "#F59E0B" },
  { label: "Low", value: "low", color: "#22C55E" },
] as const

interface Props {
  onExport: () => void
  isExportDisabled: boolean
  reportingPeriodLabel: string | null
  activePriorityTab: string
  onPriorityTabClick: (priority: string) => void
}

export const IntelligenceReportsHeader = ({
  onExport,
  isExportDisabled,
  reportingPeriodLabel,
  activePriorityTab,
  onPriorityTabClick,
}: Props) => (
  <>
    <TableNavButton onClick={onExport} disabled={isExportDisabled}>
      Export
    </TableNavButton>
    {reportingPeriodLabel && <ReportingPeriod>Reporting Period: {reportingPeriodLabel}</ReportingPeriod>}
    <StyledTabsWrapper>
      <TabsContainer>
        {STATUS_TABS.map(tab => (
          <Tab
            key={tab.value}
            active={activePriorityTab === tab.value}
            tabColor={tab.color}
            onClick={() => onPriorityTabClick(tab.value)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabsContainer>
    </StyledTabsWrapper>
  </>
)
